scrollHere();

function scrollHere(){
    var scrollHeight = $('.scrollHere').offset().top;

    $("html, body").animate({
        scrollTop: scrollHeight
    }, 1000);

};